module.exports = __webpack_public_path__ + "static/media/man.ce2bf5ad.png";